import React from 'react';

import EditablePage from '@/components/aem-core/editable-page';
import type { ModelPageRenderer } from '@/components/atomic/atoms/utils/model-page-renderer/typings';
import usePageModel from '@/hooks/use-page-model';

const ModelPageRenderer: React.FC<ModelPageRenderer> = ({
	fragmentVariationPath,
	manipulator,
	mockedModel,
}) => {
	const pageModel = usePageModel(
		fragmentVariationPath,
		manipulator,
		mockedModel,
	);

	if (!pageModel) return null;

	return (
		<EditablePage
			pageModel={{ ...pageModel }}
			key={fragmentVariationPath}
		/>
	);
};

export default ModelPageRenderer;
